import { ValidateIf } from '@pristine-ts/class-validator';
import { translationBaseKey } from '../../../../../decorators/translation-base-key.decorator';
import { clonePropertyMetadata } from '@pristine-ts/metadata';
import { IncomeTaxPersonalSpouseFederalOptions } from '../federal/income-tax-personal-spouse-federal.options';
import {CalculationDate} from '../../../../../models/calculation.date';

@translationBaseKey('income-tax-personal-spouse-federal-in-income-tax-personal-options')
export class IncomeTaxPersonalSpouseFederalInIncomeTaxPersonalOptions implements Omit<IncomeTaxPersonalSpouseFederalOptions,
  'a3Line13200' |
  'birthdate' |
  'businessIncome' |
  'contributionsEI' |
  'contributionsQPIP' |
  'contributionsQPP' |
  'contributionsRDSP' |
  'employmentIncome' |
  'employmentIncomeForEI' |
  'enhancedContributionsQPP' |
  'firstName' |
  'id' |
  'isCanadianResidentForFullYear' |
  'isDead' |
  'isDisabled' |
  'isEligibleToCWB' |
  'isEmployeeSubjectToEI' |
  'isExemptedIncomeOfficial' |
  'isInPrison' |
  'lastName' |
  'numberOfMonthsFullTimeSchool' |
  'numberOfMonthsOptionA' |
  'numberOfWeeksOptionB' |
  'otherIncome' |
  'othersIncomesLine13000' |
  'realEligibleDividend' |
  'realNonEligibleDividend'> {

  @clonePropertyMetadata<IncomeTaxPersonalSpouseFederalOptions>(IncomeTaxPersonalSpouseFederalOptions, 'maximumAllowedDeductibleContributionsRRSP')
  @ValidateIf(o => o.paidContributionRRSP > 0)
    // todo set a warning if paid contribution > maximum allowed.
  maximumAllowedDeductibleContributionsRRSP: number = 0;

  @clonePropertyMetadata<IncomeTaxPersonalSpouseFederalOptions>(IncomeTaxPersonalSpouseFederalOptions, 'paidContributionRRSP')
  paidContributionRRSP: number;
}
